import React, { useEffect } from "react"
import Layout from "~/components/Layout";
import { useLang } from "~/hooks/useLang";
import AuditQualifiersTable from "../components/Qualifiers";

export default function AuditQualifiers() {
    const { translate } = useLang();

    useEffect(() => {
        document.title = translate('Audit Qualifiers - Dispatch System')
    }, [])
    return (
        <Layout marginLayout={true}>
            <AuditQualifiersTable />
        </Layout>
    )
}